export interface AscendantHistoryEntry {
    birthdate: string;
    birthtime: string;
    birthlocation: number;
    ascendant: string;
    timestamp: string;
}

const STORAGE_KEY = 'ascendant_history';
const MAX_HISTORY_ITEMS = 10;

export const saveToHistory = (entry: Omit<AscendantHistoryEntry, 'timestamp'>): AscendantHistoryEntry[] => {
    try {
        const history = getHistory();
        const newEntry: AscendantHistoryEntry = {
            ...entry,
            timestamp: new Date().toISOString()
        };
        const updatedHistory = [newEntry, ...history].slice(0, MAX_HISTORY_ITEMS);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHistory));
        return updatedHistory;
    } catch (error) {
        console.error('Error saving to history:', error);
        return [];
    }
};

export const getHistory = (): AscendantHistoryEntry[] => {
    try {
        const history = localStorage.getItem(STORAGE_KEY);
        return history ? JSON.parse(history) : [];
    } catch (error) {
        console.error('Error reading history:', error);
        return [];
    }
};

export const clearHistory = (): boolean => {
    try {
        localStorage.removeItem(STORAGE_KEY);
        return true;
    } catch (error) {
        console.error('Error clearing history:', error);
        return false;
    }
};

